import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      © 2025 PiggyBank. All rights reserved.
    </footer>
  );
}

export default Footer;